export enum Roles {
  admin = 'admin',
  user = 'user',
}
